import React, { useState, useRef } from 'react';
import { CustomAccordionMenu } from "components";
import { EsgAddFile, SaveIconWithPencil, SaveIcon } from 'assets';
import { CreateFromTemplate, SaveAsTemplate, UploadTemplate, UploadTemplateRef } from './components';

export const TemplateActionsButton = () => {
    const [isTemplateDialogOpen, setIsTemplateDialogOpen] = useState(false);
    const [isCreateTemplateDialogOpen, setIsCreateTemplateDialogOpen] = useState(false);
    const uploadTemplateRef = useRef<UploadTemplateRef>(null);

    const onUploadTemplateClick = () => {
        setIsTemplateDialogOpen(true);
    };

    const onSaveAsTemplateClick = () => {
        setIsCreateTemplateDialogOpen(true);
    };

    const onUploadExcelTemplateClick = () => {
        uploadTemplateRef.current?.triggerFileUpload();
    };

    return (
        <>
            <CustomAccordionMenu
                title="Template Actions"
                initialIcon={<EsgAddFile />}
                sx={{ width: '252px', height: '36px' }}
                buttons={[
                    {
                        label: 'Save Card as Template',
                        icon: <SaveIcon />,
                        onClick: onSaveAsTemplateClick,
                        sx: { fontSize: '14px', fontWeight: '500' }
                    },
                    {
                        label: 'Create from Saved Template',
                        icon: <SaveIconWithPencil />,
                        onClick: onUploadTemplateClick,
                        sx: { fontSize: '14px', fontWeight: '500' }
                    },
                    {
                        label: 'Create from Excel Template',
                        icon: <SaveIconWithPencil />,
                        onClick: onUploadExcelTemplateClick,
                        sx: { fontSize: '14px', fontWeight: '500' }
                    },
                ]}
            />

            <SaveAsTemplate
                isOpen={isCreateTemplateDialogOpen}
                onClose={() => setIsCreateTemplateDialogOpen(false)}
            />

            <CreateFromTemplate
                isOpen={isTemplateDialogOpen}
                onClose={() => setIsTemplateDialogOpen(false)}
            />

            <UploadTemplate ref={uploadTemplateRef} />
        </>
    );
};